import React from 'react';

import { LargeForecastCardWrap } from '../../../styles';
import { CardBodyBottomSectionLoadingUI } from './cardBodyBottomSectionLoadingUI';
import { CardBodyTopSectionLoadingUI } from './cardBodyTopSectionLoadingUI';

export const CardBodyLoadingUI = () => {
    return (
        <LargeForecastCardWrap>
            <CardBodyTopSectionLoadingUI />
            <CardBodyBottomSectionLoadingUI />
        </LargeForecastCardWrap>
    );
};
